import React from 'react';
import { Icon, IconName } from 'components/Icon/Icon';
import classNames from 'classnames';

interface IProps {
	variant?: 'default' | 'error';
	className?: string;
	children: React.ReactNode;
}

export const Alert: React.FC<IProps> = ({ variant = 'default', className, children }) => {
	const isError = variant === 'error';

	return (
		<div
			className={classNames(
				'w-full p-2 border border-solid rounded-md flex items-center gap-2',
				isError ? 'bg-red-01-new border-red-03-new' : 'bg-blue-01-new border-blue-03-new',
				className,
			)}>
			<Icon
				name={isError ? IconName.errorCircle : IconName.infoCircle}
				className={classNames('shrink-0', isError ? 'text-red-06-new' : 'text-blue-600')}
			/>
			<div className="text-grey-10-new text-sm">{children}</div>
		</div>
	);
};
